import * as Blockly from 'blockly/core'

const SPRITE_OPTIONS = [
  ['kiko', 'kiko'],
  ['apel', 'apel'],
  ['batu', 'batu'],
  ['dinding', 'dinding'],
]

export function registerLogicBlocks() {
  Blockly.common.defineBlocksWithJsonArray([
    {
      type: 'logic_if',
      message0: '❓ kalau %1 maka',
      args0: [{ type: 'input_value', name: 'COND', check: 'Boolean' }],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 30,
      inputsInline: true,
      tooltip: 'Jalankan blok di dalam jika kondisi benar',
    },
    {
      type: 'logic_if_else',
      message0: '❓ kalau %1 maka',
      args0: [{ type: 'input_value', name: 'COND', check: 'Boolean' }],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      message2: 'kalau tidak %1',
      args2: [{ type: 'input_statement', name: 'ELSE' }],
      previousStatement: null,
      nextStatement: null,
      colour: 30,
      inputsInline: true,
      tooltip: 'Jalankan blok DO jika kondisi benar, ELSE jika salah',
    },
    {
      type: 'logic_compare_equal',
      message0: '⚖️ %1 = %2',
      args0: [
        { type: 'input_value', name: 'A' },
        { type: 'input_value', name: 'B' },
      ],
      inputsInline: true,
      output: 'Boolean',
      colour: 30,
      tooltip: 'Benar jika A sama dengan B',
    },
    {
      type: 'logic_compare_less',
      message0: '⚖️ %1 < %2',
      args0: [
        { type: 'input_value', name: 'A' },
        { type: 'input_value', name: 'B' },
      ],
      inputsInline: true,
      output: 'Boolean',
      colour: 30,
      tooltip: 'Benar jika A lebih kecil dari B',
    },
    {
      type: 'logic_compare_greater',
      message0: '⚖️ %1 > %2',
      args0: [
        { type: 'input_value', name: 'A' },
        { type: 'input_value', name: 'B' },
      ],
      inputsInline: true,
      output: 'Boolean',
      colour: 30,
      tooltip: 'Benar jika A lebih besar dari B',
    },
    {
      type: 'logic_touching',
      message0: '🤝 menyentuh %1?',
      args0: [{ type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS }],
      output: 'Boolean',
      colour: 30,
      tooltip: 'Benar jika sprite ini menyentuh sprite lain',
    },
  ])
}
